import { Fragment, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/pro-regular-svg-icons";

import preventDefault from "../../../helpers/components/preventDefault";
import FileSelectModal from "./FileSelectModal";
import { FileData } from "../../../@types/files";

type FilesEditorViewArgs = {
  currentRootFolder: unknown;
  onSelectFiles: (selectedFiles: FileData[]) => void;
  disabled?: boolean;
};

export default function FilesEditorView({
  currentRootFolder,
  onSelectFiles,
  disabled = false,
}: FilesEditorViewArgs) {
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);

  return (
    <Fragment>
      {" "}
      <span>{I18n.t("js.or")}</span>
      {/* type="button": inside a form the default (submit) would make this
          the form's first submit button — Enter in any text field then
          "clicks" it via implicit submission and opens the select modal
          instead of saving */}
      <button
        type="button"
        className="btn btn-light btn-sm file-selector-select"
        onClick={preventDefault(() => setShowModal(true))}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faFile} className="pr-1" />
        {I18n.t("js.files.file_selector.select")}
      </button>
      {showModal && (
        <FileSelectModal
          closeModal={closeModal}
          currentRootFolder={currentRootFolder}
          onSelectFiles={onSelectFiles}
        />
      )}
    </Fragment>
  );
}
